import React, { FC, useState } from 'react'

import { observer } from 'mobx-react'

import cn from 'classnames'

import { toast } from 'App'
import Button from 'components/Button'
import ButtonIcon from 'components/ButtonIcon'

import { useStore } from 'store'

import NFTIcon from 'sources/images/NFT_Icon.png'

import { CropImageAvatarModal } from '../СropImageAvatarModal'

import styles from './styles.module.scss'

interface IProps {
  onSaveImage: (data: File, openSeaLink?: string) => void
}

//Resize
export const NFTBlock: FC<IProps> = observer(({ onSaveImage }) => {
  const { profile, mediaQuery } = useStore()
  const [nftLink, setNftLink] = useState<string>('')

  const [isOpenCropImage, setIsOpenCropImage] = useState<boolean>(false)
  const [imageAvatar, setImageAvatar] = useState<string>()
  const [imageFile, setImageFile] = useState<File>()

  const onChangeNftInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNftLink(e.target.value)
  }

  const onClickOpenNftImage = async () => {
    if (!nftLink) return

    try {
      if (nftLink && nftLink.match('https://opensea.io/assets')) {
        const arrString = nftLink.split('/').filter(item => item)
        const tokenId = arrString[arrString.length - 1]
        const contract = arrString[arrString.length - 2]

        const NFTLinkAvatar = await profile.checkNFT(tokenId, contract)

        fetch(NFTLinkAvatar)
          .then(resp => resp.blob())
          .then(blob => {
            if (
              blob.type !== 'image/png' &&
              blob.type !== 'image/jpeg' &&
              blob.type !== 'image/gif'
            ) {
              return toast({
                type: 'warning',
                message:
                  'You can only use JPG, JPEG, PNG, GIF formats for your profile picture',
              })
            }
            if (blob.type === 'image/gif') {
              // const bodySolution = new FormData()
              // bodySolution.append('file', new File([blob], 'nft.gif', { type: blob.type }))
              setIsOpenCropImage(false)
              onSaveImage &&
                onSaveImage(
                  new File([blob], 'nft.gif', { type: blob.type }),
                  nftLink
                )
            } else {
              const fileName = blob.type === 'image/png' ? 'nft.png' : 'nft.jpg'
              setImageInfo(new File([blob], fileName, { type: blob.type }))
            }
          })
          .catch(() =>
            toast({
              type: 'error',
              message: 'Error loading NFT information. Please, try again.',
            })
          )
      } else {
        toast({
          type: 'error',
          message: 'Wrong NFT link',
        })
      }
    } catch (e: any) {
      toast({
        type: 'error',
        message: e.message ? e.message : 'Wrong NFT link',
      })
    }
  }

  const setImageInfo = (file: File) => {
    setImageFile(file)
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = function () {
      setImageAvatar(reader.result as string)
      setIsOpenCropImage(true)
    }
  }

  const uploadImage = () => {
    let input = document.getElementById(`logo_image`)
    if (input) input.click()
  }
  return (
    <div className={styles.container}>
      <img className={styles.nftIcon} src={NFTIcon} alt="" />
      <div className={styles.nftBlock}>
        <div className={styles.nftInfoBox}>
          <ButtonIcon
            style={{
              minWidth: mediaQuery.minWidth_2200 ? '16px' : '13px',
              width: mediaQuery.minWidth_2200 ? '16px' : '13px',
              height: mediaQuery.minWidth_2200 ? '16px' : '13px',
              margin: '1px',
            }}
            styleIcon={{
              width: mediaQuery.minWidth_2200 ? '8px' : '7px',
              height: mediaQuery.minWidth_2200 ? '8px' : '7px',
            }}
            icon={'info'}
            tooltip="Please copy / paste OpenSea token link of desired NFT profile picture. NFT must be in your wallet."
            tooltipPosition="top-start"
            bordered
          />
        </div>
        <input
          placeholder="NFT image link"
          className={cn({
            [styles.nftInput]: true,
          })}
          type="text"
          value={nftLink}
          onChange={onChangeNftInput}
        />
        <Button
          style={{
            width: mediaQuery.minWidth_2200 ? '45px' : '38px',
            minWidth: mediaQuery.minWidth_2200 ? '45px' : '38px',
            height: mediaQuery.minWidth_2200 ? '28px' : '23px',
            background:
              'linear-gradient(131.69deg, #1f45c3 6.46%, #0e219b 100%)',
          }}
          onClick={onClickOpenNftImage}
          styleText={{
            color: '#ffffff',
            fontSize: mediaQuery.minWidth_2200 ? '12px' : '10px',
            fontWeight: 'bold',
          }}
          btnStyle="classic"
          text="Save"
        />
        <CropImageAvatarModal
          imageAvatar={imageAvatar}
          imageFile={imageFile}
          isOpenCropImage={isOpenCropImage}
          setIsOpenCropImage={setIsOpenCropImage}
          onSaveImage={onSaveImage}
          uploadImage={uploadImage}
          nftLink={nftLink}
        />
      </div>
    </div>
  )
})
